import { apiConnector } from "../apiConnector";
import { assignmentEndpoints } from "../apis";

const {
  GET_ASSIGNMENTS_API,
  GET_ASSIGNMENTS_BY_USER_ID_API,
  GET_ASSIGNMENTS_BY_ID_API,
  UPDATE_ASSIGNMENT_STATUS_API,
} = assignmentEndpoints;

//  Get single assignment by ID
export function getAssignmentById(assignmentId) {
  return async () => {
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      // const toastId = toast.loading("Loading assignment...");

      const response = await apiConnector(
        "GET",
        `${GET_ASSIGNMENTS_BY_ID_API}/${assignmentId}`,
        null,
        {
          Authorization: `Bearer ${token}`,
        }
      );

      // toast.success("Assignment loaded successfully");
      console.log("GET ASSIGNMENT BY ID", response.data);
      return response.data;
    } catch (error) {
      console.error("GET ASSIGNMENT BY ID ERROR:", error);
      // toast.error("Failed to load assignment");
      return null;
    } finally {
      // toast.dismiss(toastId);
    }
  };
}

//by userid
export function getAssignmentByUserId(userId) {
  return async () => {
    try {
      const response = await apiConnector(
        "GET",
        `${GET_ASSIGNMENTS_BY_USER_ID_API}/${userId}`
      );

      // toast.success("Assignment loaded successfully");
     // console.log("GET ASSIGNMENT BY User ID", response.data);
      return response.data;
    } catch (error) {
     // console.error("GET ASSIGNMENT BY ID ERROR:", error);
      // toast.error("Failed to load assignment");
      return null;
    } finally {
      // toast.dismiss(toastId);
    }
  };
}

//  Get assignments for logged-in user
export function getAssignments() {
  return async () => {
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      // Optional loading toast
      // const toastId = toast.loading("Loading assignments...");

      const response = await apiConnector("GET", GET_ASSIGNMENTS_API, null, {
        Authorization: `Bearer ${token}`,
      });

      // toast.success("Assignments loaded successfully");
      return response.data;
    } catch (error) {
      console.error("GET ASSIGNMENTS ERROR:", error);
      //  toast.error("Failed to load assignments");
      return [];
    } finally {
      // toast.dismiss(toastId);
    }
  };
}

//  Update assignment status
export function updateAssignmentStatus(assignmentId, status, marks) {
  return async () => {
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      // const toastId = toast.loading("Updating status...");

      const response = await apiConnector(
        "PUT",
        `${UPDATE_ASSIGNMENT_STATUS_API}/${assignmentId}`,
        { status, marks },
        {
          Authorization: `Bearer ${token}`,
        }
      );

      // toast.success("Assignment status updated successfully");
      return response.data;
    } catch (error) {
      console.error("UPDATE ASSIGNMENT STATUS ERROR:", error);
      // toast.error("Failed to update assignment status");
      return null;
    } finally {
      // toast.dismiss(toastId);
    }
  };
}
